import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { BASE_URL } from '../config/api';

const EditSalesVisit = () => {
    const { id } = useParams(); // Get the ID from the URL parameters
    const navigate = useNavigate();
    
    const [salesVisit, setSalesVisit] = useState({
        name: '',
        area: '',
        city: '',
        sales: '',
        description: '',
        image: ''
    });
    
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    // Fetch the sales visit details based on the ID
    useEffect(() => {
        fetch(`${BASE_URL}salesvisits/${id}`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    setSalesVisit(data.data); // Set the sales visit data to the state
                    setLoading(false); // Set loading to false once data is fetched
                } else {
                    setError('Failed to fetch sales visit details');
                    setLoading(false);
                }
            })
            .catch(error => {
                setError('Error fetching sales visit details');
                setLoading(false);
            });
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setSalesVisit({
            ...salesVisit,
            [name]: value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Update the sales visit data
        fetch(`${BASE_URL}salesvisits/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(salesVisit),
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    alert('Sales visit updated successfully!');
                    navigate('/SalesVisitsList'); // Redirect to Sales Visits List page after successful update
                } else {
                    alert('Failed to update sales visit');
                }
            })
            .catch(error => {
                console.error('Error updating sales visit:', error);
                alert('Error updating sales visit');
            });
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit Sales Visit</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4>Edit Sales Visit Details</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">Firm Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="name"
                                            name="name"
                                            value={salesVisit.name}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="area" className="form-label">Area</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="area"
                                            name="area"
                                            value={salesVisit.area}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="city" className="form-label">City</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="city"
                                            name="city"
                                            value={salesVisit.city}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>


                                    <div className="mb-3">
                                        <label htmlFor="sales" className="form-label">PCS of Sale</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="sales"
                                            name="sales"
                                            value={salesVisit.sales}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="description" className="form-label">Description</label>
                                        <textarea
                                            className="form-control"
                                            id="description"
                                            name="description"
                                            value={salesVisit.description}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="image" className="form-label">Image URL</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="image"
                                            name="image"
                                            value={salesVisit.image}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <button type="submit" className="btn btn-primary">Update Sales Visit</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EditSalesVisit;
